import { store } from '../index';
import { foundGame } from '../redux/actions/ingameActions';
import {
	resetScore,
	setHandPoints,
	setRoundsScore,
	setRoundsToWin,
} from '../redux/actions/scoreActions';
import {
	enableHand,
	disableHand,
	resetHand,
	setCards,
	setCurrentPlayer,
	playCard,
	throwCard,
} from '../redux/actions/handActions';
import { setClock, showClock } from '../redux/actions/clockActions';
import {
	showDice,
	setHighestBet,
	resetHighestBet,
} from '../redux/actions/diceActions';
import {
	showSuit,
	showChosenSuit,
	setSuit,
} from '../redux/actions/suitActions';
import { redirect } from '../redux/actions/redirectActions';

import { setMyIndex } from '../redux/actions/myIndexActions';

// game-start listener
// This listener starts all ingame listeners
export const gameStartListener = (socketClient, body) => {
	//
	store.dispatch(foundGame(true));
	store.dispatch(resetScore());
	store.dispatch(enableHand(1));
	// store.dispatch();

	console.log(body);
	// Update static state
	const { roundsToWin, turnDuration, playerCount, roomURL } = body;
	store.dispatch(setRoundsToWin(roundsToWin));
	store.dispatch({ type: 'SET_TURN_DURATION', value: turnDuration });
	store.dispatch({ type: 'SET_PLAYER_COUNT', value: playerCount });
	//
	//

	// start all listeners
	socketClient.on('your-index', yourIndexListener);

	socketClient.on('current-player-idx', currentPlayerListener);
	socketClient.on('card-distribution', distributionListener);

	socketClient.on('bet', betListener);
	socketClient.on('trumpet', trumpetListener);
	socketClient.on('play', playListener);
	socketClient.on('new-hand', newHandListener);

	socketClient.on('new-round', newRoundListener);
	socketClient.on('current-round-points', currentRoundPoints);
	socketClient.on('round-finished', roundFinished);

	socketClient.on('game-finished', gameFinishedListener);
	socketClient.on('game-score', updateGameScore);
	socketClient.on('cheating-vote', cheatVoteListener);
};

// your index listener
const yourIndexListener = (body) => {
	const { yourIdx, playerId } = body;
	console.log('youridx', yourIdx);
	// set your index state
	store.dispatch(setMyIndex(yourIdx));
};

// current player listener
const currentPlayerListener = (body) => {
	const { currentPlayerIdx, expectedAction } = body;
	console.log('currentPlayerIdx', currentPlayerIdx, body);

	// check if this index is the same as mine
	const { myIndex, clock } = store.getState();
	console.log('myIndex', myIndex);
	//
	store.dispatch(showClock(false));

	if (myIndex.myIndex === currentPlayerIdx) {
		// reset clock ==> stop then restart clock
		store.dispatch(showDice(false));

		// start clock
		store.dispatch(showClock(true, 'bottom'));

		if (expectedAction === 'make-bet') {
			console.log('this is make bet expectation');
			// show dice
			store.dispatch(showDice(true));
			store.dispatch(disableHand(0));
		}

		if (expectedAction === 'choose-trumpet') {
			store.dispatch(disableHand(0));
			store.dispatch(showSuit(true)); //show the popup to choose a trumpet
		}

		if (expectedAction === 'play') {
			store.dispatch(showSuit(false));

			store.dispatch(enableHand(1));
		}
	} else {
		const playerPosition = getPlayerPosition(myIndex.myIndex, currentPlayerIdx);
		console.log(playerPosition);
		store.dispatch(showDice(false));
		store.dispatch(showClock(true, playerPosition));
		store.dispatch(disableHand(0));
	}
};
// card disctribution listener
const distributionListener = (body) => {
	console.log(body);
	//

	store.dispatch(setCards(body.playerCards, body.extend));
};

// bet listener
const betListener = (body) => {
	console.log(body);
	const { playerIdx, bet } = body;

	const { myIndex, dice } = store.getState();
	console.log(dice.highestBet);

	if (bet > dice.highestBet) {
		//  set highest bet
		store.dispatch(setHighestBet(bet));
	}
	// console.log('my index', myIndex, 0);
	console.log(myIndex, playerIdx);
	if (myIndex.myIndex === playerIdx) {
		// store.dispatch(makeBet(bet, 'buttom'));
	} else {
		// find position of who played
		// console.log('other player made a play');
		// if(1vs1){
		// 	store.dispatch()
		// }
		// store.dispatch(makeBet(bet, 'top')); //TODO: update this har coded 'top'
	}
};

// trumpet listener
const trumpetListener = (body) => {
	const { trumpet } = body;
	console.log('trumpet', trumpet, body);

	const suits = ['heart', 'nut', 'leave', 'bell'];

	store.dispatch(setSuit(suits[trumpet]));
	store.dispatch(showChosenSuit(true));
	store.dispatch(resetHighestBet());
};

// play listener
const playListener = (body) => {
	const { playerIdx, suite, value } = body;

	// check if this index is the same as mine
	const { myIndex } = store.getState();

	const position = getPlayerPosition(myIndex.myIndex, playerIdx);

	store.dispatch(throwCard(suite, value, position)); //TODO: update this har coded 'top'
};

// new Hand listener
const newHandListener = () => {
	console.log('new hand..');
	// reset the cards
	setTimeout(() => {
		store.dispatch(resetHand());
	}, 800);
};

// new rounds listener
const newRoundListener = () => {
	console.log('new round..');
	// reset the cards
	store.dispatch(resetHand());
};

const currentRoundPoints = (body) => {
	console.log(body);
	const { currentRoundPoints } = body;
	const { myIndex } = store.getState().myIndex;
	console.log(currentRoundPoints);

	let ourPoints, opponentPoints;
	const sumOfCurrentRoundPoints = currentRoundPoints.reduce((a, b) => a + b, 0);

	if (currentRoundPoints.length === 4) {
		if (myIndex + 2 < currentRoundPoints.length) {
			ourPoints = currentRoundPoints[myIndex] + currentRoundPoints[myIndex + 2];
			opponentPoints = sumOfCurrentRoundPoints - ourPoints;
		} else {
			ourPoints =
				currentRoundPoints[myIndex] + currentRoundPoints[(myIndex + 2) % 4];
			opponentPoints = sumOfCurrentRoundPoints - ourPoints;
		}
	} else {
		ourPoints = currentRoundPoints[myIndex];
		opponentPoints = sumOfCurrentRoundPoints - ourPoints;
	}

	// const opponentPoints =
	// 	currentRoundPoints[myIndex.myIndex + (1 % 2) === 0 ? 0 : myIndex.myIndex + 1];

	// store.dispatch(setHandPoints({ ourPoints, opponentPoints }));
	store.dispatch(
		setHandPoints({
			ourPoints,
			opponentPoints,
		})
	);
};

const roundFinished = (body) => {
	console.log(body);
	const { teamZeroPoints, teamOnePoints } = body;

	const { myIndex } = store.getState().myIndex;

	let ourRounds, opponentRounds;
	//
	if (myIndex === 0 || myIndex === 2) {
		ourRounds = teamZeroPoints;
		opponentRounds = teamOnePoints;
	} else {
		ourRounds = teamOnePoints;
		opponentRounds = teamZeroPoints;
	}

	store.dispatch(setRoundsScore({ ourRounds, opponentRounds }));
	store.dispatch(setHandPoints({ ourPoints: 0, opponentPoints: 0 }));
	store.dispatch(showChosenSuit(false));
};

const updateGameScore = (body) => {
	const { teamZeroPoints, teamOnePoints } = body;
	const { myIndex } = store.getState().myIndex;

	let ourRounds, opponentRounds;
	//
	if (myIndex === 0 || myIndex === 2) {
		ourRounds = teamZeroPoints;
		opponentRounds = teamOnePoints;
	} else {
		ourRounds = teamOnePoints;
		opponentRounds = teamZeroPoints;
	}
	store.dispatch(setRoundsScore({ ourRounds, opponentRounds }));
};
// gamefinished listener
const gameFinishedListener = () => {
	console.log('GAME FINISHED');
	store.dispatch({ type: 'RESET_WHOLE_STATE' });
	store.dispatch(redirect(''));
};

const getPlayerPosition = (myIndex, playerIdx) => {
	// my action
	if (myIndex === playerIdx) return 'bottom';

	// 1 vs 1 and not my index
	const { playerCount } = store.getState().clock;
	// const playerCount = 4;
	if (playerCount === 2) {
		return 'top';
	}

	if (myIndex === playerIdx + 2 || (myIndex + 2) % 4 === playerIdx) return 'top';

	if (myIndex === playerIdx - 1 || (myIndex + 1) % 4 === playerIdx)
		return 'left';

	if (myIndex === playerIdx + 1 || (playerIdx + 1) % 4 === myIndex)
		return 'right';

	// return 'right';
};

//
const cheatVoteListener = (body) => {
	store.dispatch({ type: 'SHOW_CHEAT_VOTE', value: body.value });
};
